import React from 'react';
import PropTypes from 'prop-types';
import { FileUploader } from '@tfecom-thermofisher/react-komodo-design';

import { Message } from 'src/core/components';

import messages from './messages';

const UploadSingleFile = ({
  file,
  uploadFile,
  resetData,
  acceptedFileTypes,
}) => {
  const getUploadStatusMessage = () => {
    let message = messages.noUploadedFile;

    if (file?.isUploading) {
      message = messages.uploading;
    }

    if (file?.error) {
      message = messages.uploadFailed;
    }

    return <Message message={message} />;
  };

  return (
    <FileUploader
      type="simple"
      files={Object.keys(file || {}).length ? [file] : []}
      fileBrowseTitle={
        file?.error ? (
          <Message message={messages.chooseNewFile} />
        ) : (
          <Message message={messages.chooseFile} />
        )
      }
      uploadFile={uploadFile}
      deleteFile={resetData}
      uploadStatusMessage={getUploadStatusMessage()}
      acceptedFileTypes={acceptedFileTypes}
    />
  );
};

UploadSingleFile.propTypes = {
  file: PropTypes.object,
  acceptedFileTypes: PropTypes.array,
  uploadFile: PropTypes.func.isRequired,
  resetData: PropTypes.func.isRequired,
};

export default UploadSingleFile;
